module.exports = __webpack_public_path__ + "img/sb.099702ef.gif";